export default {
    updateSavers: (state, data) => {
        state.savers = data
        console.log(state.savers)
    }
}